import { createContext } from 'react';

export interface UserInfo {
  givenName?: string;
  surname?: string;
  mail?: string;
}

interface UserContextProperties {
  userInfo?: UserInfo;
}

export const UserInfoContext = createContext<UserContextProperties>({
  userInfo: undefined,
});
